import BaseView from '@/store/modules/components/BaseView'

export default class ServicesView extends BaseView {
    constructor() {
        super('services')
    }
}
